<template>
    <div class="settings-view">
        <v-sheet max-width="600" class="mx-auto">

            <v-form ref="form" class="text-primary">
                <h1 class="ma-0 mt-2 text-h4">
                    Настройки
                    <v-btn v-if="isChange"
                           class="ml-2"
                           color="primary"
                           @click="saveSettings">
                        Сохранить изменения
                    </v-btn>
                </h1>

                <v-card :elevation="7"
                        class="text-primary mt-4 w-100"
                        title="Диапазон дат">
                    <v-card-text>
                        <v-text-field v-model="countOfShowedDays"
                                      :class="{'text-blue-grey': isChangedCountOfShowedDays}"
                                      type="number"
                                      :min="1"
                                      :max="40"
                                      label="Количество дней"
                                      required />

                        <v-radio-group v-model="countOfDaysBeforeCurrent"
                                       class="mb-n4"
                                       :class="{'text-blue-grey': isChangedCountOfDaysBeforeCurrent}"
                                       inline>
                            <v-radio label="с позапрошлого дня" :value="2" />
                            <v-radio label="с прошлого дня" :value="1" />
                            <v-radio label="с текущего дня" :value="0" />
                        </v-radio-group>
                    </v-card-text>
                </v-card>

                <v-card :elevation="7"
                        class="text-primary mt-4 w-100"
                        title="Итог дня">
                    <v-card-text>
                        <v-checkbox v-model="showDayResult"
                                    class="my-n4"
                                    :class="{'text-blue-grey': isChangedShowDayResult}"
                                    label="Показывать итог дня" />

                        <v-checkbox v-if="showDayResult"
                                    v-model="showDayResultText"
                                    class="ml-12 my-n4"
                                    :class="{'text-blue-grey': isChangedShowDayResultText}"
                                    label="Показывать сообщение итога дня" />

                        <v-checkbox v-if="showDayResult"
                                    v-model="showDayResultRating"
                                    class="ml-12 my-n4"
                                    :class="{'text-blue-grey': isChangedShowDayResultRating}"
                                    label="Показывать смайлики итога дня" />
                    </v-card-text>
                </v-card>

                <v-card :elevation="7"
                        class="text-primary mt-4 w-100"
                        title="Пожелания">
                    <v-card-text>
                        <v-checkbox v-model="showMorningCitation"
                                    class="my-n4"
                                    :class="{'text-blue-grey': isChangedShowMorningCitation}"
                                    label="Показывать утреннее пожелание" />

                        <v-checkbox v-model="showEveningCitation"
                                    class="my-n4"
                                    :class="{'text-blue-grey': isChangedShowEveningCitation}"
                                    label="Показывать вечернее пожелание" />

                        <v-checkbox v-if="!isDisabledShowSweetText"
                                    v-model="showSweetText"
                                    class="ml-12 my-n4"
                                    :class="{'text-blue-grey': isChangedShowSweetText}"
                                    label="Показывать уменьшительно-ласкательные пожелания" />
                    </v-card-text>
                </v-card>

                <v-card :elevation="7"
                        class="text-primary mt-4  w-100"
                        title="Привычки">
                    <v-card-text>
                        <v-checkbox v-model="showHabits"
                                    class="my-n4"
                                    :class="{'text-blue-grey': isChangedShowHabits}"
                                    label="Показывать привычки" />

                        <v-text-field v-if="showHabits"
                                      v-model="habitsCount"
                                      class="ml-12 mb-n4"
                                      :class="{'text-blue-grey': isChangedHabitsCount}"
                                      type="number"
                                      :min="1"
                                      label="Количество привычек"
                                      required />
                        <v-label class="ml-12 text-caption">Желательно не больше трёх</v-label>
                    </v-card-text>
                </v-card>

                <div class="d-flex flex-row mt-4">
                    <v-spacer />

                    <v-btn color="secondary"
                           :disabled="!isChange"
                           @click="resetSettings">
                        Отменить
                    </v-btn>

                    <v-btn color="primary"
                           class="ml-3"
                           :disabled="!isChange"
                           @click="saveSettings">
                        Сохранить изменения
                    </v-btn>
                </div>
            </v-form>
        </v-sheet>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                showMorningCitation: false,
                showEveningCitation: false,
                showSweetText: false,

                showHabits: false,
                habitsCount: 0,

                countOfDaysBeforeCurrent: 0,
                countOfShowedDays: 0,

                showDayResultText: false,
                showDayResultRating: false
            };
        },

        mounted() {
            this.loadSettings();
        },

        computed: {
            initialShowMorningCitation() {
                return this.$store.state.clientSettings?.showMorningCitation;
            },
            initialShowEveningCitation() {
                return this.$store.state.clientSettings?.showEveningCitation;
            },
            initialShowSweetText() {
                return this.$store.state.clientSettings?.showSweetText;
            },
            initialShowHabits() {
                return this.$store.state.clientSettings?.showHabits;
            },
            initalHabitsCount() {
                return this.$store.state.clientSettings?.habitsCount;
            },
            initalCountOfDaysBeforeCurrent() {
                return this.$store.state.clientSettings?.countOfDaysBeforeCurrent;
            },
            initalCountOfShowedDays() {
                return this.$store.state.clientSettings?.countOfShowedDays;
            },
            initialShowDayResultText() {
                return this.$store.state.clientSettings?.showDayResultText;
            },
            initialShowDayResultRating() {
                return this.$store.state.clientSettings?.showDayResultRating;
            },

            showDayResult: {
                get() {
                    return this.showDayResultText === true
                        || this.showDayResultRating === true;
                },
                set(newValue) {
                    this.showDayResultText = newValue;
                    this.showDayResultRating = newValue;
                }
            },
            initialShowDayResult() {
                return this.initialShowDayResultText === true
                    || this.initialShowDayResultRating === true;
            },

            isDisabledShowSweetText() {
                return !this.showMorningCitation && !this.showEveningCitation;
            },

            isChangedShowMorningCitation() {
                return this.showMorningCitation != this.initialShowMorningCitation;
            },
            isChangedShowEveningCitation() {
                return this.showEveningCitation != this.initialShowEveningCitation;
            },
            isChangedShowSweetText() {
                return this.showSweetText != this.initialShowSweetText;
            },
            isChangedShowHabits() {
                return this.showHabits != this.initialShowHabits;
            },
            isChangedHabitsCount() {
                return this.habitsCount != this.initalHabitsCount;
            },
            isChangedCountOfDaysBeforeCurrent() {
                return this.initalCountOfDaysBeforeCurrent != this.countOfDaysBeforeCurrent;
            },
            isChangedCountOfShowedDays() {
                return this.initalCountOfShowedDays != this.countOfShowedDays;
            },

            isChangedShowDayResultText() {
                return this.initialShowDayResultText != this.showDayResultText;
            },
            isChangedShowDayResultRating() {
                return this.initialShowDayResultRating != this.showDayResultRating;
            },
            isChangedShowDayResult() {
                return this.initialShowDayResult != this.showDayResult;
            },

            isChange() {
                return this.isChangedShowMorningCitation
                    || this.isChangedShowEveningCitation
                    || this.isChangedShowSweetText
                    || this.isChangedShowHabits
                    || this.isChangedHabitsCount
                    || this.isChangedCountOfDaysBeforeCurrent
                    || this.isChangedCountOfShowedDays
                    || this.isChangedShowDayResultText
                    || this.isChangedShowDayResultRating;
            }
        },

        watch: {
            initialShowMorningCitation(newValue) {
                this.showMorningCitation = newValue;
            },
            initialShowEveningCitation(newValue) {
                this.showEveningCitation = newValue;
            },
            initialShowSweetText(newValue) {
                this.showSweetText = newValue;
            },
            initialShowHabits(newValue) {
                this.showHabits = newValue;
            },
            initalHabitsCount(newValue) {
                this.habitsCount = newValue;
            },
            initalCountOfDaysBeforeCurrent(newValue) {
                this.countOfDaysBeforeCurrent = newValue;
            },
            initalCountOfShowedDays(newValue) {
                this.countOfShowedDays = newValue;
            },
            initialShowDayResultText(newValue) {
                this.showDayResultText = newValue;
            },
            initialShowDayResultRating(newValue) {
                this.showDayResultRating = newValue;
            },

            isDisabledShowSweetText() {
                this.showSweetText = this.initialShowSweetText;
            },
            showHabits() {
                this.habitsCount = this.initalHabitsCount;
            },

            habitsCount(newValue, oldValue) {
                const newNumber = Number.parseInt(newValue);
                const oldNumber = Number.parseInt(oldValue);

                if (!Number.isInteger(newNumber) && Number.isInteger(oldNumber)) {
                    this.habitsCount = oldNumber;
                    return;
                }
                if (!Number.isInteger(newNumber)) {
                    this.habitsCount = 1;
                    return;
                }
                if (newNumber < 1) {
                    this.habitsCount = 1;
                    return;
                }
                if (newNumber > 10) {
                    this.habitsCount = 10;
                    return;
                }

                this.habitsCount = newNumber;
            },

            countOfShowedDays(newValue, oldValue) {
                const newNumber = Number.parseInt(newValue);
                const oldNumber = Number.parseInt(oldValue);

                if (!Number.isInteger(newNumber) && Number.isInteger(oldNumber)) {
                    this.countOfShowedDays = oldNumber;
                    return;
                }
                if (!Number.isInteger(newNumber)) {
                    this.countOfShowedDays = 1;
                    return;
                }
                if (newNumber < 1) {
                    this.countOfShowedDays = 1;
                    return;
                }
                if (newNumber > 40) {
                    this.countOfShowedDays = 40;
                    return;
                }

                this.countOfShowedDays = newNumber;
            }
        },

        methods: {
            resetSettings() {
                this.showMorningCitation = this.initialShowMorningCitation;
                this.showEveningCitation = this.initialShowEveningCitation;
                this.showSweetText = this.initialShowSweetText;
                this.showHabits = this.initialShowHabits;
                this.habitsCount = this.initalHabitsCount;
                this.countOfDaysBeforeCurrent = this.initalCountOfDaysBeforeCurrent;
                this.countOfShowedDays = this.initalCountOfShowedDays;
                this.showDayResultText = this.initialShowDayResultText;
                this.showDayResultRating = this.initialShowDayResultRating;
            },

            loadSettings() {
                this.$store.dispatch("loadClientSettings")
                    .then(() => {
                        this.resetSettings();
                    });
            },

            saveSettings() {
                const newSettings = {
                    id: this.$store.state.clientSettings.id,
                    showMorningCitation: this.showMorningCitation,
                    showEveningCitation: this.showEveningCitation,
                    showSweetText: this.showSweetText,
                    showHabits: this.showHabits,
                    habitsCount: this.habitsCount,
                    countOfDaysBeforeCurrent: this.countOfDaysBeforeCurrent,
                    countOfShowedDays: this.countOfShowedDays,
                    showDayResultText: this.showDayResultText,
                    showDayResultRating: this.showDayResultRating
                };

                this.$store.dispatch("saveClientSettings", newSettings)
                    .then(() => {
                        this.loadSettings();
                    });
            }
        }
    };
</script>

<style lang="scss">
    .settings-view {
    }
</style>